// css file
import "../css/swiper-bundle.min.css";
import "../sass/style.scss";
//import fixedHeader from './modules/fixedHeader';
//import viewPort from './modules/viewPort';
//import pageLoader from './modules/pageLoader';
//import cursor from './modules/cursor';
import marquee from "./modules/marquee";
//import Masonry from 'masonry-layout/masonry';
import $ from "jquery";
import Swiper from "swiper/bundle";



const bootstrap = (window.bootstrap = require("bootstrap"));

// trigger tooltip

const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

// logo marquee
marquee(".marquee .marquee-wrapper", {
  speed: 20,
  pauseOnHover: true,
});
marquee(".reverse-marquee .marquee-wrapper", {
  speed: 20,
  reverse: true,
  pauseOnHover: true,
});

// logo slider
let logoSwiper = new Swiper(".logo-slider", {
  loop: true,
  slidesPerView: 2.5,
  spaceBetween: 30,
  autoplay: {
    delay: 1000, // Increase this value to set a faster autoplay speed (e.g., 1000ms for 1 second)
  },
  breakpoints: {
    1200: {
      slidesPerView: 6.75,
    },
    768: {
      slidesPerView: 4.75,
    },
    576: {
      slidesPerView: 3.5,
    },
    375: {
      slidesPerView: 2.5,
      spaceBetween: 60,
      centeredSlides: true,
    },
  },
});

// brand slider
let brandSwiper = new Swiper(".brand-slider", {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 20,
  breakpoints: {
    1200: {
      slidesPerView: 6.25,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 4.75,
    },
    576: {
      slidesPerView: 3.5,
    },
    375: {
      slidesPerView: 2.5,
    },
  },
});

var achetypesSwiper = new Swiper(".achetypes_Swiper", {
  loop: false,
  slidesPerView: 1.9,
  spaceBetween: 20,
  breakpoints: {
    576: {
      slidesPerView: 2,
    },
  },
});


let videos = document.querySelector('.videos-section');
if(videos){
  let iframes = videos.querySelectorAll("iframe");
  iframes.forEach((iframe) => {
    // Create a new <div> element
    let div = document.createElement('div');
    div.classList.add("ratio", "ratio-16x9", "mb-5");
    // Append the <iframe> as a child of the <div>
    div.appendChild(iframe.cloneNode(true)); // Clone the iframe to avoid moving it

    // Replace the original <iframe> with the newly created <div> in the DOM
    iframe.parentNode.replaceChild(div, iframe);
  });
}

let shareButton  = document.querySelector("#modalShare .modal-share-icon");
if(shareButton){
  shareButton.addEventListener("click",() => {
    let shareInputLink = document.querySelector('#modalShare .modal-share-input');
    let shareMessage = document.querySelector('#modalShare .modal-share-message');

// Check if the element was found before attempting to access its value
    if (shareInputLink) {
      // Get the value of the input element
      let inputValue = shareInputLink.value;

      // Use the Clipboard API to write the text to the clipboard
      navigator.clipboard.writeText(inputValue)
          .then(() => {
            shareMessage.textContent = "Copied to clipboard";
            shareMessage.style.display = "block";
          })
          .catch(error => {
            shareMessage.textContent = "Unable to copy to clipboard: ";
            shareMessage.style.display = "block";
          })
          .finally(() => {
            // Hide the shareMessage div after 1 second
            setTimeout(() => {
              shareMessage.style.display = "none";
            }, 1000); // 1000 milliseconds (1 second)
          });
    }
  });
}


//landing section mobile slider
let landingSwiper = new Swiper(".landingSwiper", {
  loop: true,
  slidesPerView: 1.83,
  spaceBetween: 10,
});
let landingSwiperRev = new Swiper(".landingSwiperRev", {
  loop: true,
  slidesPerView: 1.83,
  spaceBetween: 10,
});
/*

let selectedItem = document.querySelector(".sorted-select-list li.active");
if (selectedItem) {
  let sortedSelectSpan = document.querySelector(".sorted-select span");
  let anchorText = selectedItem.querySelector("a").textContent;
  sortedSelectSpan.textContent = anchorText;
}
*/

// jquery functions
$(document).ready(function () {

  if($(".search-bar .wpcf7-form").length > 0){
    $(".search-bar .wpcf7-form").each((index,item) => {
      let email = item.querySelector(".wpcf7-email");
      let submit = item.querySelector(".wpcf7-submit");

      $(submit).attr("disabled", true);

      $(email).keyup(function() {
        let emailVal = $(email).val();
        let emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        if (emailPattern.test(emailVal)) {
          console.log("Valid email: " + emailVal);
          $(submit).attr("disabled", false);
          $(submit).addClass("bg-primary");
          $(submit).removeClass("bg-grey");
        } else {
          console.log("Invalid email: " + emailVal);
          $(submit).attr("disabled", true);
          $(submit).removeClass("bg-primary");
          $(submit).addClass("bg-grey");
        }
      });
    });
  }


  if ($("#toggle-btn").length > 0) {
    let toggleBtn = $("#toggle-btn");
    let mainNavbar = $("#main-menu");
    toggleBtn.click(function () {
      $(this).toggleClass("change");
      $("body").toggleClass("overflow-hidden");
      $(mainNavbar).toggleClass("show");
    });
  }

  if ($(".sorted-select").length > 0) {
    let sortedSelect = $(".sorted-select");
    let sortedSelectList = $(".sorted-select-list");

    // Function to close the dropdown
    function closeDropdown() {
      sortedSelectList.addClass("d-none");
      $(".sorted-select-icon").removeClass("rotate");
      $(".sorted-select").removeClass("active");
    }

    sortedSelect.click(function () {
      if (sortedSelectList.hasClass("d-none")) {
        sortedSelectList.removeClass("d-none");
        $(".sorted-select-icon").addClass("rotate");
        $(".sorted-select").addClass("active");

        // Add a click event listener to the document to close the dropdown when clicking outside
        $(document).on("click", function (event) {
          if (!$(event.target).closest(".sorted-select").length) {
            closeDropdown();
            // Remove the event listener to prevent it from interfering with future clicks
            $(document).off("click");
          }
        });
      } else {
        closeDropdown();
      }

      // Prevent the click event from propagating and immediately closing the dropdown
      event.stopPropagation();
    });
  }

  //header height
  if ($(".header").length > 0) {
    let headerHeight = $(".header").height();
    $(".offcanvas").css({ marginTop: headerHeight + "px" });
  }

  let blurOverlay = $(".overlay-blur")[0];
  //bottom header
  if ($(".search-bar").length > 0) {
    let searchbarInput = $(".search-bar-wrap .search-bar input");
    let searchbarBottomInput = $(".search-bar-bottom .search-bar input");

    //header search bar click
    searchbarInput.focus(function () {
      $(".search-bar-desc").removeClass("d-none");
      $(".header-bottom").removeClass("d-none");
      $(".header-bottom input").focus();
      $(".search-bar.top").removeClass("d-flex").addClass("d-none");
      $(blurOverlay).removeClass("d-none").addClass("d-block");
    });
    // search bar bottom input on keypress
    searchbarBottomInput.keypress(function () {
      $(".content-wrapper .search-result").removeClass("d-none");
      $(".search-bar-bottom .search-bar").addClass("active");
      $(".search-bar-bottom").addClass("bg-grey");
      $(".search-bar .cross-icon-wrap")
        .addClass("d-flex")
        .removeClass("d-none");

      if ($(".header-bottom .nav-pills .nav-link").hasClass("active")) {
        $(".header-bottom .nav-pills .nav-link").removeClass("active");
      }

      if ($(".content-wrapper .tab-pane").hasClass("active show")) {
        $(".content-wrapper .tab-pane").removeClass("active show");
      }

      $(".cross-icon-wrap").click(function () {
        searchbarBottomInput.val("");
        $(".content-wrapper .search-result").addClass("d-none");
      });
    });
    // search bar bottom input on focus
    searchbarBottomInput.keyup(function () {
      if ($(".search-bar-bottom .search-bar input").val() === "") {
        $(".content-wrapper .search-result").addClass("d-none");
      }
    });

    // if(searchbarBottomInput.val() === ""){
    //   console.log('input value blank');
    //   $(".header-bottom .search-result").addClass("d-none");
    // }

    $(document).click(function (event) {
      if (
        event.target == $(blurOverlay)[0] ||
        $(".content-wrapper").is(event.target)
      ) {
        $(blurOverlay).removeClass("d-block").addClass("d-none");
        $(".header-bottom").addClass("d-none");
        $(".search-bar").removeClass("d-none").addClass("d-flex");
        $(".search-bar-desc").addClass("d-none");
        $(".content-wrapper .search-result").addClass("d-none");
        $(".content-wrapper .tab-pane").removeClass("active show");
        $(".search-bar-bottom .search-bar").removeClass("active");
        $(".header-bottom .nav-link").removeClass("active");
        $(".search-bar-bottom").removeClass("bg-grey");
        $(".cross-icon-wrap").removeClass("d-flex").addClass("d-none");
      }
    });

    //nav-tabs click
    $(".header-bottom .nav-pills .nav-link").click(function () {
      $(".search-bar-bottom").addClass("bg-grey");
      if ($(".search-bar").hasClass("active")) {
        $(".cross-icon-wrap").removeClass("d-flex").addClass("d-none");
        $(".search-bar").removeClass("active");
      }
      if (!$(".search-result").hasClass("d-none")) {
        $(".search-result").addClass("d-none");
      }
    });
  }

  //mobile menu
  if ($(".offcanvas").length > 0) {
    $(".offcanvas .search-bar input").focus(function () {
      $(".offcanvas .search-bar").addClass("active");
      $(".search-bar .cross-icon-wrap")
        .addClass("d-flex")
        .removeClass("d-none");
    });
    $(".cross-icon-wrap").click(function () {
      $(".search-bar input").val("");
    });

    //click on close btn
    $(".offcanvas")
      .find("[aria-label='Close']")
      .click(function () {
        $(".offcanvas .search-bar").removeClass("active");
      });
  }

  var timeout = null; // A variable to store the timeout instance

  $("#search-input").on("keyup", function () {
    var query = $(this).val();

    // Clear the timeout if it exists (prevents rapid firing searches)
    if (timeout) {
      clearTimeout(timeout);
    }

    // Set a delay before executing the search to ensure user has finished typing
    timeout = setTimeout(function () {
      // Only proceed if the query length is at least 2 characters
      if (query.length >= 2) {
        $.ajax({
          url: frontendajax.ajaxurl,
          type: "POST",
          data: {
            action: "ajax_search",
            query: query,
          },
          success: function (response) {
            var results = JSON.parse(response);
            $(".search-result").empty();
            if (Array.isArray(results) && results.length) {
              $(".search-result").append(
                '<ul class="list-unstyled mb-0"></ul>'
              );
              results.forEach(function (post) {
                $(".search-result ul").append(
                  '<li class="p-1 rounded-6"><a class="text-secondary" href="' +
                    post.link +
                    '"><span class="me-1"><img class="rounded-3 border bg-white" src="' +
                    post.image +
                    '" alt=""></span>' +
                    post.title +
                    "</a></li>"
                );
              });
            }
          },
        });
      } else {
        $(".search-result").empty(); // Clear results if the query length is less than 2 characters
      }
    }, 500); // Delay in milliseconds (500ms = 0.5 seconds)
  });

  $("#search-mob-input").on("keyup", function () {
    var query = $(this).val();

    // Clear the timeout if it exists (prevents rapid firing searches)
    if (timeout) {
      clearTimeout(timeout);
    }

    // Set a delay before executing the search to ensure user has finished typing
    timeout = setTimeout(function () {
      // Only proceed if the query length is at least 2 characters
      if (query.length >= 2) {
        $.ajax({
          url: frontendajax.ajaxurl,
          type: "POST",
          data: {
            action: "ajax_search",
            query: query,
          },
          success: function (response) {
            var results = JSON.parse(response);
            $(".search-result").empty();
            $(".search-bar-result").empty();
            if (Array.isArray(results) && results.length) {

              $(".search-bar-result").append(
                  '<ul class="list-unstyled mb-0"></ul>'
              );

              results.forEach(function (post) {
                $(".search-bar-result ul").append(
                  '<li class="p-1"><a class="text-secondary" href="' +
                    post.link +
                    '"><span class="me-1"><img class="rounded-3 border bg-white" src="' +
                    post.image +
                    '" alt=""></span>' +
                    post.title +
                    "</a></li>"
                );
              });
            }
          },
        });
      } else {
        $(".search-bar-result").empty(); // Clear results if the query length is less than 2 characters
      }
    }, 500); // Delay in milliseconds (500ms = 0.5 seconds)
  });
});
